module.exports = __webpack_public_path__ + "static/media/Unicesumar_Logo.69d344d1.svg";